import { UseFormReturnType } from "@mantine/form";
import { TForm } from "../types/Aula";

export const isAnswered = (form: UseFormReturnType<TForm>, questionId: string): boolean => {
    const value = form.values[questionId];
    return Array.isArray(value) ? value.length > 0 : !!value;
};
